import template from './tab.html';
import controller from './tab.controller';
import './tab.styl';

let TabComponent = () => {
  return {
    template,
    controller,
    controllerAs: 'tab',
    restrict: 'E',
    scope: {
      tabId: '@',
      tabPosition: '@',
      tabIcon: '@',
      tabDefaultOpen: '='
    },
    transclude: true,
    require: '^tabs',
    link: (scope, elem, attr, tabsCtrl) => {
      if (scope.tabDefaultOpen) {
        scope.active = true;
      } else {
        scope.active = false;
      }
      tabsCtrl.addTab(scope);
    }
  };
};

export default TabComponent;



// WEBPACK FOOTER //
// ./src/components/tab/tab.component.js